// extracted by mini-css-extract-plugin
export default {"shankey":"Shankey_shankey__tzjV3","fade":"Shankey_fade__YhX2g","tooltip":"Shankey_tooltip__mpQl2"};